import IPage from "../../../interfaces/page";
import UserSettingsFormComponent from "../../Components/UserSettings/UserSettingsForm.component";
import Width800Layout from "../../layouts/Width800/Width800.layout";

const UserSettingsPage: React.FC<IPage> = () => {
    return <Width800Layout component={UserSettingsFormComponent} />
}

export default UserSettingsPage;